import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useMenuAIAutomationLayoutContext } from 'widgets/Menu/ui/MenuAIAutomation'
import { WorkflowLayoutStore } from 'pages/workflows/store/workflowLayoutStore'
import { WorkflowLayoutContext } from 'pages/workflows/context/workflowLayoutContext'

export const WorkflowLayout = observer(() => {
  const menuLayoutStore = useMenuAIAutomationLayoutContext()
  const pageStore = useMemo(() => new WorkflowLayoutStore(menuLayoutStore.pageLayoutStore), [])

  return (
    <WorkflowLayoutContext.Provider value={pageStore}>
      <Outlet />
    </WorkflowLayoutContext.Provider>
  )
})
